import { useId as useReactId } from 'react';

export function useAriaErrorMessageId(error: boolean | undefined, prefix?: string) {
   const reactId = useReactId();
   const id = prefix ? `${prefix}-error-${reactId}` : reactId;
   if (error) return id;
   return undefined;
}
